import Button from "@mui/material/Button";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { SearchIcon } from "lucide-react";
import React, { useState } from "react";

function SearchBox({URL, pb, setRows, setError, rows}) {

    const [query, setQuery] = useState('');
    const [date, setDate] = useState('2026-01-01');
    const [ canSearch, setCanSearch ] = useState(false);
    const [ normalCopy , setNormalCopy ] = useState(false);
    const [ showingQuery, setShowingQuery ] = useState(false);

    React.useEffect(() => {
        if (rows !== null && normalCopy === false) {
            setNormalCopy(rows);
        }
    }, [rows]);

    React.useEffect(() => {
        console.log("Query: ", query, " Date: ", date);
        const regex = /20[0-9]{2,2}-[0-1]{1,1}[0-9]{1,1}-[0-9]{2,2}/g;
        if (query.trim() !== '' && date.trim() !== '' && regex.test(date) && date.length === 10 && query.length > 2) {
            setCanSearch(true);
        } else {
            setCanSearch(false);
        }
        
    }, [date, query]);

    function send() {
        fetch(`${URL}/blaze/${query}/${date}`, {
            method: "GET",
            headers: {
                "Authorization": "Bearer " + pb.authStore.token,
            }
        }).then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json();
        }).then(data => {
            const ids = data.ids;
            if (!ids || ids.length === 0) {
                setError("Nincs találat a keresésre.");
                return;
            }
            var filter = ""
            ids.forEach((id, index) => {
                filter += `id="${id}"`;
                if (index < ids.length - 1) {
                    filter += " || ";
                }
            });
            pb.collection('results').getList(1, data.ids.length, {
                filter: filter,
            }).then(records => {
                setRows(records);
            })
            setShowingQuery(true);
        }).catch(error => {
            console.error('There was a problem with the fetch operation:', error);
        })
    }

    return (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
        <div style={{ width: "90vw", display: "flex", flexDirection: "row", alignItems: "center", marginTop: "20px", }}>
            <TextField type="text"
                sx={{ width: "60vw"}}
                placeholder="Keresés..."
                label="Keresés"
                value={query}
                onChange={(e) => setQuery(e.target.value)} />    
            <TextField type="text"
                placeholder="Dátum (YYYY-MM-DD)"
                label="Dátum"
                value={date}
                onChange={(e) => setDate(e.target.value)}
                sx={{ marginLeft: "10px" }}
            />
            <Button variant="contained" color="secondary" startIcon={<SearchIcon />} sx={{ marginLeft: "10px", minWidth: "130px", padding: "15px" }} disabled={!canSearch} onClick={send} >Keresés</Button>
        </div>
        {
            showingQuery && <a onClick={ () => {
                setRows(normalCopy);
                setShowingQuery(false);
            }}><Typography variant="body2" sx={{ marginTop: "10px", cursor: "pointer", textDecoration: "underline" }}>Vissza a teljes listához</Typography></a>
        }
        </div>
        );
}

export default SearchBox;